<template>
<v-dialog v-model="open" scrollable persistent>
  <v-card v-if="open">
    <v-card-title class="px-4 pb-4">
      Histórico de status
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="padding: 10px">
      <table class="yeep-table">
        <tr v-if="vehicle">
          <td colspan="2">{{ vehicle.description }}</td>
        </tr>
        <tr v-if="vehicle">
          <td colspan="2" class="py-3">
            <img :src="vehicle.vehicle_plate_photo_url" height="95px">
          </td>
        </tr>
        <tr v-for="log in logs" :key="log.id">
          <td>
            <b>{{ service_status_select(log.description).title }}</b>
          </td>
          <td style="max-width: 22px; white-space: nowrap;">
            {{ log.user.name }} <br/>
            <b>{{ formatDate(log.created_at) }}</b>
          </td>
        </tr>
      </table>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" outlined block depressed @click="closeDialog({entity: 'logs'})">
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from "dayjs";

export default {
  props: {
    open: Boolean,
    logs: Array,
    vehicle: Object,
  },
  computed: {
    service_status_list () {
      return this.$store.getters['General/organization_status_list'];
    },
  },
  methods: {
    service_status_select(code) {
      return this.service_status_list.find((status) => status.code.toUpperCase() === code.toUpperCase());
    },
    formatDate(date) {
      return dayjs(date).locale('pt-br').format("DD/MM/YYYY - HH:mm");
    },
    closeDialog(data) {
      this.$emit('close-dialog', data);
    }
  },
};
</script>

<style lang="scss">
.yeep-table {
  width: 100%;
  border: 2px solid #bebebe;
  font-size: 18px;
  border-radius: 5px;
  text-transform: uppercase;

  &.normal-text {
    text-transform: none;
  }

  tr {
    text-align: center;

    td {
      border: 1px solid #d9d9d9;
      padding: 4px 8px;
      border-radius: 5px;
      max-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 15px;

      &.text-left {
        text-align: left !important;
      }
    }
  }
}
</style>
